import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { ActivitiesService } from '../../../services/activities/activities.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'up-employee-activities',
  templateUrl: './employee-activities.component.html',
  styleUrls: ['./employee-activities.component.scss']
})
export class EmployeeActivitiesComponent implements OnInit {
  activities$: Observable<any>;
  error$: Observable<any>;
  uuid: string;
  unit: string;

  constructor(private activitiesService: ActivitiesService, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.uuid = params.p;
      this.unit = params.u;
    });
    this.loadActivities();
  }

  loadActivities(): void {
    this.activities$ = this.activitiesService.getActivities(this.uuid);
  }
}
